import React from 'react';
import { FormFieldV2 as FormField, SearchFieldV2 as SearchField } from '@/components/custom/erp';
import { SearchFieldActions, SearchFieldState } from '../../hooks';
import { donViSearchColumns, QUERY_KEYS } from '@/constants';
import { Label } from '@/components/ui/label';
import { DonViCoSo } from '@/types/schemas';

interface FilterTabProps {
  formState: {
    state: SearchFieldState;
    actions: SearchFieldActions;
  };
}

const FilterTab = ({ formState: { state, actions } }: FilterTabProps) => {
  return (
    <div className='space-y-3 p-4 pt-0'>
      {/* Đơn vị */}
      <div className='flex items-center gap-3'>
        <Label className='w-[150px] shrink-0 text-[13px]'>Đơn vị</Label>
        <SearchField<DonViCoSo>
          name='unit'
          searchEndpoint={`/${QUERY_KEYS.DON_VI}/`}
          searchColumns={donViSearchColumns}
          columnDisplay='ma_unit'
          displayRelatedField='ten_unit'
          dialogTitle='Danh mục đơn vị'
          value={state.donVi?.ma_unit}
          relatedFieldValue={state.donVi?.ten_unit}
          onRowSelection={actions.setDonVi}
          className='w-100'
        />
      </div>

      {/* Trạng thái */}
      <div className='flex items-center gap-3'>
        <Label className='w-[150px] shrink-0 text-[13px]'>Trạng thái</Label>
        <FormField
          name='status'
          type='select'
          className='w-48'
          options={[
            { value: '', label: 'Tất cả' },
            { value: '0', label: 'Chưa ghi sổ' },
            { value: '3', label: 'Đã ghi sổ' },
            { value: '5', label: 'Chờ duyệt' },
            { value: '9', label: 'Hủy' }
          ]}
        />
      </div>

      {/* Lọc theo người SD */}
      <div className='flex items-center gap-3'>
        <Label className='w-[150px] shrink-0 text-[13px]'>Lọc theo người sử dụng</Label>
        <FormField
          name='filterByUser'
          type='select'
          className='w-48'
          options={[
            { value: '', label: 'Tất cả' },
            { value: '1', label: 'Lọc theo người tạo' }
          ]}
        />
      </div>
    </div>
  );
};

export default FilterTab;
